import React from 'react';
import { Form, Header, Message, Button, Icon } from 'semantic-ui-react';
import { buildObjectsArr } from '../../helper/helper.js';
import { commonFileExtensions } from '../../helper/form-helper.js'
import admHOC from './admHOC.js';

class AdmFormRequirements extends React.Component {

  // This is not a stateless component but it uses its state only for the fileformats

  componentWillMount() {
    const fileFormats = commonFileExtensions.map( elem => {
      return {key: elem, text: elem, value: elem};
    });
    this.setState({ fileFormats });
  }

  componentWillReceiveProps(nextProps) {
    // need to add fileformat that isn't in the default list to appear in option
    let additionalFormats = [];
    if(nextProps.formValues.fileFormats) {
      nextProps.formValues.fileFormats.forEach(elem => {
        if (!commonFileExtensions.includes(elem)) {
          additionalFormats.push({key: elem, text: elem, value: elem})
        }
      });
    }
    this.setState({fileFormats: this.state.fileFormats.concat(additionalFormats)})
  }

  handleAddition = (e, { value }) => {
    // This function is necessary to allow user to add values for dropdown of file formats
    console.log({fileFormats: [...this.state.fileFormats, { key: value, text: value, value }]});
    this.setState({
      fileFormats: [...this.state.fileFormats, { key: value, text: value, value }],
    })
  };

  render() {

    const { formValues, formFieldValidity, submitAttempted, keyEditable } = this.props;
    const disableButtons = this.props.processing || !formFieldValidity._form || !formValues.key;

    const actions = buildObjectsArr(this.props.actions);
    const reqtypes = buildObjectsArr(this.props.reqtypes);
    const optnActions = actions.map( acy =>  ({key: acy.key, text:`${this.props.channels[acy.chanId]['name']}: ${acy.name}`, value: acy.key}) );
    const optnReqTypes = reqtypes.map( reytype =>  ({icon: reytype.icon, text: reytype.name, value: reytype.key}) );

    const fanoutKeyObj = {
      parentPath: 'actions',
      child: formValues.actionId,
      endpoint: 'reqIds',
      data: formValues.key
    };

    return (
      <Form as='form'
        error={!formFieldValidity._form}
        onReset={this.props.handleReset}
        onSubmit={ (e) => {
          this.props.handleSubmit('requirements', e, [fanoutKeyObj]);
        }}>
        <Header dividing>
          <Icon name='list ol'/>
          <Header.Content>Requirement</Header.Content>
          <Header.Subheader>Add, Edit or Delete</Header.Subheader>
        </Header>

        <Form.Input required name='key' label='Key'
          readOnly={!keyEditable}
          onChange={this.props.handleChange}
          error={!formFieldValidity.key && submitAttempted}
          value={formValues.key}
          placeholder='Key required, please choose on the left or click "add new"'
        />

        <Form.Checkbox name='published' label='published'
          checked={formValues.published}
          disabled
        />

        <Form.Select search required
          label='Action' name='actionId' placeholder='Action...'
          options={optnActions}
          value={formValues.actionId}
          onChange={this.props.handleChange}
        />

        <Form.Input required name='name' label='Name'
          onChange={this.props.handleChange}
          error={!formFieldValidity.name && submitAttempted}
          value={formValues.name}
        />

        <Form.TextArea required name='descr'
          label={`Description (Ideal < 50 Characters. You: ${formValues.descr.length})`}
          onChange={this.props.handleChange}
          error={!formFieldValidity.descr && submitAttempted}
          value={formValues.descr}
        />

        <Form.Input required name='maxMByte' label='max. MByte'
          onChange={this.props.handleChange}
          error={!formFieldValidity.maxMByte && submitAttempted}
          value={formValues.maxMByte}
        />

        <Form.Dropdown required search selection
          label='Requirement Type' name='reqTypeId' placeholder='Requirement Types...'
          options={optnReqTypes}
          value={formValues.reqTypeId}
          onChange={this.props.handleChange}
        />

        <Form.Dropdown search selection multiple allowAdditions
          label='File Formats' name='fileFormats' placeholder='File Formats...'
          options={this.state.fileFormats}
          value={ formValues.fileFormats  || [] }
          onChange={this.props.handleChange}
          onAddItem={this.handleAddition}
        />

        <Message error className='formMsg'>
          <Message.Header>You shall not pass!</Message.Header>
          <Message.List items={formFieldValidity._msgList} />
        </Message>

        <Button color='red' icon='trash' basic
          type='button'
          disabled={disableButtons}
          onClick={ (e) => this.props.confirmDeletion('requirements', e, [], [fanoutKeyObj]) }
        />

        <Button.Group >
          <Button
            basic
            color='grey'
            type='reset'>
            Reset Form
          </Button>
          <Button
            primary
            disabled={disableButtons}
            type='submit'
            >
            Submit
          </Button>
        </Button.Group>

      </Form>
    );
  }

}

export default admHOC(AdmFormRequirements);



// WEBPACK FOOTER //
// ./src/components/forms/AdmFormRequirements.js